export default {
  RTP: '96.11%',
  GAME_WIDTH: 2340,
  GAME_HEIGHT: 1080,
  MINIMAL_SPIN_TIME: 600,
  COLUMNS_COUNT: 6,
  LINES_COUNT: 6,
  SYMBOLS: {
    width: 147,
    height: 134,
    topOffset: 16.5,
    sideOffset: 4,
  },
  WILD_ID: 1,
  BIG_WIN_COEFS: [10, 20, 30],
}
